module.exports = __webpack_public_path__ + "img/gift-clubfun-icon4.c56b7279.png";